import { Fragment } from 'react';
import MuiIconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const IconButton = ({ tooltip, ...props }) => {
    const Wrapper = tooltip ? Tooltip : Fragment;
    const wrapperProps = tooltip ? { title: tooltip } : {};
    return (
        <Wrapper {...wrapperProps}>
            <MuiIconButton aria-label={tooltip} {...props} />
        </Wrapper>
    );
};

export default IconButton;
